import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export default function Index() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session?.user) {
        const { data: roles } = await supabase
          .from('fr_user_roles')
          .select('role')
          .eq('user_id', session.user.id);

        if (roles && roles.length > 0) {
          const roleSet = new Set(roles.map(r => r.role));
          if (roleSet.has('hq_admin') || roleSet.has('brand_owner')) {
            navigate('/franchise/hq', { replace: true });
          } else if (roleSet.has('accountant')) {
            navigate('/franchise/employees/accountant', { replace: true });
          } else if (roleSet.has('dispatcher')) {
            navigate('/franchise/employees/dispatcher', { replace: true });
          } else if (roleSet.has('mystery_shopper')) {
            navigate('/franchise/employees/mystery', { replace: true });
          } else {
            navigate('/franchise/hq', { replace: true });
          }
          return;
        }
      }
      setChecking(false);
    });
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return <Navigate to="/auth" replace />;
}
